/**
 * @generated SignedSource<<441a2893578a26a0585e87a83c83055c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignUpCompletePhotoRouteQuery$variables = Record<PropertyKey, never>;
export type SignUpCompletePhotoRouteQuery$data = {
  readonly me: {
    readonly " $fragmentSpreads": FragmentRefs<"SignupClientCompletePhotoScreen_user">;
  } | null | undefined;
};
export type SignUpCompletePhotoRouteQuery = {
  response: SignUpCompletePhotoRouteQuery$data;
  variables: SignUpCompletePhotoRouteQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignUpCompletePhotoRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SignupClientCompletePhotoScreen_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SignUpCompletePhotoRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "photoURL",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c36de92ccb182883176b26612d447d94",
    "id": null,
    "metadata": {},
    "name": "SignUpCompletePhotoRouteQuery",
    "operationKind": "query",
    "text": "query SignUpCompletePhotoRouteQuery {\n  me {\n    ...SignupClientCompletePhotoScreen_user\n    id\n  }\n}\n\nfragment SignupClientCompletePhotoScreen_user on User {\n  id\n  photoURL\n}\n"
  }
};

(node as any).hash = "c3f63f050356df3338523901782d49bc";

export default node;
